import WasmController from "react-lib/frameworks/WasmController";
import * as DentalRecordI from "react-lib/apps/common/CUDENT/DentalRecordInterface";

import * as DENI from "./DENInterface";
import * as DPOI from "./DPOI";
import * as DiagnosisTodayI from "./DiagnosisTodayInterface";
import * as DiagramI from "./DiagramInterface";
import * as TreatmentTodayI from "./TreatmentTodayInterface";
import * as PlaqueRecordI from "./diagram/PlaqueRecordI";
import * as ReExaminationI from "./ReExaminationI";

export type DENEvent = DENI.Event | { message: string; params?: any };

// Controller ของ Ex & Tx Created / Tx.Processing / Dental History
export default class DENController extends WasmController<DENI.State, DENEvent, any, any> {
  constructor(getState: () => DENI.State, setState: any, window: any) {
    super(getState, setState, window, {});
  }

  handleEvent = (e: DENEvent): any => {
    console.log(e.message, e.params, "DEN_H");

    // handler แต่ละไฟล์ประกาศ type state / event ของตัวเอง
    const controller = this as any;

    switch (e.message) {
      // ----- Load
      case "DidMount":
        return DENI.DidMount(controller, e.params);
      case "LoadPatientEncounter":
        return DENI.LoadPatientEncounter(controller, e.params);
      case "SetHostProps":
        return DENI.SetHostProps(controller, e.params);

      case "GetExamination":
        DPOI.GetExamination(controller, e.params);
        return;
      case "GetDivisionSearch":
        return DPOI.GetDivisionSearch(controller, e.params);
      case "GetDoctorSearch":
        return DPOI.GetDoctorSearch(controller, e.params);
      case "handleSetTemplateChiefComplaintShortcut":
        DiagnosisTodayI.handleSetTemplateChiefComplaintShortcut(controller, e.params);
        return;
      case "SaveDiagnosis":
        DiagnosisTodayI.SaveDiagnosis(controller, e.params);
        return;
      case "SetMedHistory":
        DiagnosisTodayI.SetMedHistory(controller, e.params);
        return;
      case "AddClinicalFinding":
        DPOI.AddClinicalFinding(controller, e.params);
        return;
      case "AddClinicalFindingByLocation":
        DPOI.AddClinicalFinding(controller, e.params);
        return;
      case "SaveClinicalFindingById":
        DiagnosisTodayI.SaveClinicalFindingById(controller, e.params);
        return;
      case "RemoveClinicalFinding":
        DiagnosisTodayI.RemoveClinicalFinding(controller, e.params);
        return;
      case "SaveDrawingOverlay":
        DiagnosisTodayI.SaveDrawingOverlay(controller, e.params);
        return;
      case "RemoveClinicalFindingById":
        DPOI.RemoveClinicalFindingById(controller, e.params);
        return;
      case "SetPatientSpecialTooth":
        DiagnosisTodayI.SetPatientSpecialTooth(controller, e.params);
        return;
      case "SetSuperTooth":
        return DPOI.SetSuperTooth(controller, e.params);
      case "UnSetSuperTooth":
        return DPOI.UnSetSuperTooth(controller, e.params);
      case "SetHideBabyTooth":
        DPOI.SetHideBabyTooth(controller, e.params);
        return;
      case "UnsetHideBabyTooth":
        DPOI.UnsetHideBabyTooth(controller, e.params);
        return;
      case "SelectedDiagramItem":
        DPOI.SelectedDiagramItem(controller, e.params);
        return;
      case "GetSuperToothList":
        DPOI.GetSuperToothList(controller, e.params);
        return;
      case "GetSpecialToothByExaminations":
        DPOI.GetSpecialToothByExaminations(controller, e.params);
        return;
      case "GetTreatmentTodayMasterData":
        TreatmentTodayI.GetTreatmentTodayMasterData(controller, e.params);
        return;
      case "refreshCurrentTreatment":
        TreatmentTodayI.refreshCurrentTreatment(controller, e.params);
        return;
      case "handleUpdateTreatmentPlanDisplaySeq":
        TreatmentTodayI.handleUpdateTreatmentPlanDisplaySeq(controller, e.params);
        return;
      case "handleUpdateTreatmentPlanSeq":
        TreatmentTodayI.handleUpdateTreatmentPlanSeq(controller);
        return;
      case "handleUpdateTreatmentPlan":
        TreatmentTodayI.handleUpdateTreatmentPlan(controller, e.params);
        return;
      case "handleCancelTreatmentPlan":
        TreatmentTodayI.handleCancelTreatmentPlan(controller, e.params);
        return;
      case "handleUpdateTreatmentPlanIssue":
        TreatmentTodayI.handleUpdateTreatmentPlanIssue(controller, e.params);
        return;
      case "GetTreatmentPlanList":
        TreatmentTodayI.GetTreatmentPlanList(controller, e.params);
        return;
      case "GetTreatmentSearchList":
        return TreatmentTodayI.GetTreatmentSearchList(controller, e.params);
      case "GetEmployeeTokenization":
        return TreatmentTodayI.GetEmployeeTokenization(controller, e.params);
      case "handleDuplicateTreatmentPlan":
        TreatmentTodayI.handleDuplicateTreatmentPlan(controller, e.params);
        return;
      case "handleCompleteTreatmentPlan":
        TreatmentTodayI.handleCompleteTreatmentPlan(controller, e.params);
        return;
      case "AddTreatmentPlanIssue":
        TreatmentTodayI.AddTreatmentPlanIssue(controller, e.params);
        return;
      case "CancelTreatmentPlan":
        TreatmentTodayI.CancelTreatmentPlan(controller, e.params);
        return;
      case "AddTreatmentPlan":
        TreatmentTodayI.AddTreatmentPlan(controller, e.params);
        return;
      case "SaveTreatmentPlan":
        return TreatmentTodayI.SaveTreatmentPlan(controller, e.params);
      case "SetDentistFilterTp":
        TreatmentTodayI.SetDentistFilterTp(controller, e.params);
        return;
      case "SetUrgencyLevelFilterTp":
        TreatmentTodayI.SetUrgencyLevelFilterTp(controller, e.params);
        return;
      case "SetCurrentLocationFilterTp":
        TreatmentTodayI.SetCurrentLocationFilterTp(controller, e.params);
        return;
      case "SetCurrentPrincipalFilterTp":
        TreatmentTodayI.SetCurrentPrincipalFilterTp(controller, e.params);
        return;
      case "SetCurrentTpFilterTp":
        TreatmentTodayI.SetCurrentTpFilterTp(controller, e.params);
        return;
      case "SetCurrentClinicFilterTp":
        TreatmentTodayI.SetCurrentClinicFilterTp(controller, e.params);
        return;
      case "SetCurrentStatusFilterTp":
        TreatmentTodayI.SetCurrentStatusFilterTp(controller, e.params);
        return;
      case "SetCurrentCreatedFilterTp":
        TreatmentTodayI.SetCurrentCreatedFilterTp(controller, e.params);
        return;
      case "HandleTreatmentIssueGallery":
        TreatmentTodayI.HandleTreatmentIssueGallery(controller, e.params);
        return;
      case "HandleTreatmentIssueDrawing":
        TreatmentTodayI.HandleTreatmentIssueDrawing(controller, e.params);
        return;
      case "HandleSetSelectTreatmentRecord":
        TreatmentTodayI.HandleSetSelectTreatmentRecord(controller, e.params);
        return;
      case "SetSelectionMode":
        DiagramI.setSelectionMode(controller, e.params);
        return;
      case "AddLocation":
        DentalRecordI.AddLocation(controller, e.params);
        return;
      case "ToggleLocation":
        DentalRecordI.ToggleLocation(controller, e.params);
        return;
      case "ToggleClinicalTags":
        DiagnosisTodayI.ToggleClinicalTags(controller, e.params);
        return;
      case "SaveKeyboardShortcut":
        DiagnosisTodayI.SaveKeyboardShortcut(controller, e.params);
        return;
      case "DeleteKeyboardShortcut":
        DiagnosisTodayI.DeleteKeyboardShortcut(controller, e.params);
        return;
      case "SetKeyboardShortcutToClinicalFinding":
        DiagnosisTodayI.SetKeyboardShortcutToClinicalFinding(controller, e.params);
        return;
      case "GetReExaminationEncounter":
        DiagnosisTodayI.GetReExaminationEncounter(controller, e.params);
        return;
      case "GetMedicalHistoryByEncounter":
        DiagnosisTodayI.getMedicalHistoryByEncounter(controller, e.params);
        return;

      // ----- Periodontium
      case "handleGetMissingTooth":
        PlaqueRecordI.handleGetMissingTooth(controller);
        return;
      case "GetPeriodontium":
        PlaqueRecordI.GetPeriodontium(controller, e.params);
        return;
      case "handleChangePeriodontiumRecordData":
        PlaqueRecordI.handleChangePeriodontiumRecordData(controller, e.params);
        return;
      case "handleSavePeriodontiumRecordData":
        PlaqueRecordI.handleSavePeriodontiumRecordData(controller, e.params);
        return;
      case "SetPlaque":
        PlaqueRecordI.SetPlaque(controller, e.params);
        return;
      case "SetBleeding":
        PlaqueRecordI.SetBleeding(controller, e.params);
        return;
      case "RecalPlaqueBleed":
        PlaqueRecordI.RecalPlaqueBleed(controller, e.params);
        return;
      case "CalculatePlaqueIndex":
        return PlaqueRecordI.CalculatePlaqueIndex(controller, e.params);
      case "CalculateBleedingIndex":
        return PlaqueRecordI.CalculateBleedingIndex(controller, e.params);
      case "handleGetPeriodontiumHistory":
        PlaqueRecordI.handleGetPeriodontiumHistory(controller);
        return;
      case "handleGetPeriodontalExam":
        PlaqueRecordI.handleGetPeriodontalExam(controller);
        return;
      case "SetCheckedPeriodontalExam":
        PlaqueRecordI.SetCheckedPeriodontalExam(controller, e.params);
        return;
      case "handleSavePeriodontalExam":
        PlaqueRecordI.handleSavePeriodontalExam(controller);
        return;

      // ----- Drawing / Evaluation
      case "SetOpenModalDrawing":
        DiagnosisTodayI.SetOpenModalDrawing(controller, e.params);
        return;
      case "SetToggleShowDrawingOverlay":
        DiagnosisTodayI.SetToggleShowDrawingOverlay(controller, e.params);
        return;
      case "SetCloseOpenGallery":
        DiagnosisTodayI.SetCloseOpenGallery(controller, e.params);
        // ปิด gallery แล้วล้าง showDrawingChecked ด้วย
        DiagnosisTodayI.SetToggleShowDrawingAll(controller, e.params);
        return;
      case "SetToggleShowDrawingAll":
        DiagnosisTodayI.SetToggleShowDrawingAll(controller, e.params);
        return;
      case "SetCheckedDentalCaries":
        DiagramI.SetCheckedDentalCaries(controller, e.params);
        return;
      case "SetActiveIndexDentalCaries":
        DiagramI.SetActiveIndexDentalCaries(controller, e.params);
        return;
      case "SetNextSectionDentalCaries":
        DiagramI.SetNextSectionDentalCaries(controller, e.params);
        return;
      case "CloseModalDentalExam":
        DiagramI.CloseModalDentalExam(controller, e.params);
        return;
      case "GetEvaluationFormList":
        DiagramI.GetEvaluationFormList(controller, e.params);
        return;
      case "SaveAssessmentForm":
        DiagramI.SaveAssessmentForm(controller, e.params);
        return;
      case "SaveEvaluationForm":
        DiagramI.SaveEvaluationForm(controller, e.params);
        return;

      case "SetCheckedMuscleExam":
        DiagnosisTodayI.SetCheckedMuscleExam(controller, e.params);
        return;
      case "SetCheckedSoftTissueExam":
        DiagnosisTodayI.SetCheckedSoftTissueExam(controller, e.params);
        return;
      case "SetCheckedFaceExam":
        DiagnosisTodayI.SetCheckedFaceExam(controller, e.params);
        return;
      case "SetCheckedDentalExam":
        DiagnosisTodayI.SetCheckedDentalExam(controller, e.params);
        return;

      // ----- Dental History
      case "ChangeHistoryReviewSubTab":
        return DPOI.ChangeHistoryReviewSubTab(controller, e.params);
      case "handleGetHistoryVisit":
        return DPOI.handleGetHistoryVisit(controller, e.params);
      case "handleGetHistoryEx":
        return DPOI.handleGetHistoryEx(controller, e.params);
      case "handleGetHistoryTp":
        return DPOI.handleGetHistoryTp(controller, e.params);
      case "SetDoctorFilterVisit":
        return DPOI.SetDoctorFilterVisit(controller, e.params);
      case "SetClinicFilter":
        return DPOI.SetClinicFilter(controller, e.params);
      case "SetClinicFilterEx":
        return DPOI.SetClinicFilterEx(controller, e.params);
      case "SetClinicFilterTp":
        return DPOI.SetClinicFilterTp(controller, e.params);
      case "SetDoctorFilterEx":
        return DPOI.SetDoctorFilterEx(controller, e.params);
      case "SetDoctorFilterTp":
        return DPOI.SetDoctorFilterTp(controller, e.params);
      case "SetLocationFilter":
        return DPOI.SetLocationFilter(controller, e.params);
      case "SetLocationFilterTp":
        return DPOI.SetLocationFilterTp(controller, e.params);
      case "SetStatusFilter":
        return DPOI.SetStatusFilter(controller, e.params);
      case "SetClinicalFindingFilter":
        return DPOI.SetClinicalFindingFilter(controller, e.params);
      case "SetTreatmentCodeFilterTp":
        return DPOI.SetTreatmentCodeFilterTp(controller, e.params);
      case "SetTreatmentFilterTp":
        return DPOI.SetTreatmentFilterTp(controller, e.params);
      case "handleSetSelectedTreatmentRecord":
        return DPOI.handleSetSelectedTreatmentRecord(controller, e.params);
      case "handleOpenModGallery":
        return DPOI.handleOpenModGallery(controller, e.params);

      // ----- Re-Examination
      case "getIdEncounter":
        ReExaminationI.getIdEncounter(controller, e.params);
        return;
      case "HandleResetFilterReExam":
        ReExaminationI.HandleResetFilterReExam(controller, e.params);
        return;
      case "SetReExamDateFilter":
        ReExaminationI.SetReExamDateFilter(controller, e.params);
        return;
      case "SetReExamDentistFilter":
        ReExaminationI.SetReExamDentistFilter(controller, e.params);
        return;
      case "SetReExamClinicFilter":
        ReExaminationI.SetReExamClinicFilter(controller, e.params);
        return;

      default:
        console.warn("DENController: unhandled event", e.message);
    }
  };
}
